export const statusBadgeMap: Record<
  string,
  { className: string; icon: string; label: string }
> = {
  PENDING: { className: 'badge-warning', icon: 'ni-clock', label: 'Pending' },
  KYC_REVIEW: {
    className: 'badge-info',
    icon: 'ni-shield-check',
    label: 'KYCReview',
  },
  VALIDATION: {
    className: 'badge-warning',
    icon: 'ni-clock',
    label: 'PendingValidation',
  },
  PAYMENT_PENDING: {
    className: 'badge-warning',
    icon: 'ni-wallet',
    label: 'PaymentPending',
  },
  TRANSFER_PENDING: {
    className: 'badge-info',
    icon: 'ni-swap',
    label: 'TransferPending',
  },
  COMPLETED: {
    className: 'badge-success',
    icon: 'ni-check-circle',
    label: 'Completed',
  },
  CANCELLED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'Cancelled',
  },
  REJECTED: {
    className: 'badge-danger',
    icon: 'ni-cross-circle',
    label: 'Rejected',
  },
};

export const statusBannerMap: Record<
  string,
  { className: string; icon: string; heading: string; message: string }
> = {
  PENDING: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'OperationPendingHeading',
    message: 'OperationPendingMessage',
  },
  KYC_REVIEW: {
    className: 'alert-info',
    icon: 'ni-shield-check',
    heading: 'OperationKYCHeading',
    message: 'OperationKYCMessage',
  },
  VALIDATION: {
    className: 'alert-warning',
    icon: 'ni-clock',
    heading: 'OperationValidationHeading',
    message: 'OperationValidationMessage',
  },
  PAYMENT_PENDING: {
    className: 'alert-warning',
    icon: 'ni-wallet',
    heading: 'OperationPaymentHeading',
    message: 'OperationPaymentMessage',
  },
  TRANSFER_PENDING: {
    className: 'alert-info',
    icon: 'ni-swap',
    heading: 'OperationTransferHeading',
    message: 'OperationTransferMessage',
  },
  COMPLETED: {
    className: 'alert-success',
    icon: 'ni-check-circle',
    heading: 'OperationCompletedHeading',
    message: 'OperationCompletedMessage',
  },
  CANCELLED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'OperationCancelledHeading',
    message: 'OperationCancelledMessage',
  },
  REJECTED: {
    className: 'alert-danger',
    icon: 'ni-cross-circle',
    heading: 'OperationRejectedHeading',
    message: 'OperationRejectedMessage',
  },
};

export const timelineStepConfig: Record<
  string,
  { icon: string; description: string }
> = {
  PENDING: {
    icon: 'ni-file-text',
    description: 'OperationTimelinePendingDesc',
  },
  KYC_REVIEW: {
    icon: 'ni-shield-check',
    description: 'OperationTimelineKYCDesc',
  },
  VALIDATION: {
    icon: 'ni-building',
    description: 'OperationTimelineValidationDesc',
  },
  PAYMENT_PENDING: {
    icon: 'ni-cc-alt2',
    description: 'OperationTimelinePaymentDesc',
  },
  TRANSFER_PENDING: {
    icon: 'ni-swap',
    description: 'OperationTimelineTransferDesc',
  },
  COMPLETED: {
    icon: 'ni-file-check',
    description: 'OperationTimelineCompletedDesc',
  },
};

export const activityAvatarMap: Record<
  string,
  { bg: string; icon: string }
> = {
  PENDING: { bg: 'bg-primary-dim', icon: 'ni-user' },
  KYC_REVIEW: { bg: 'bg-success-dim', icon: 'ni-shield-check' },
  VALIDATION: { bg: 'bg-info-dim', icon: 'ni-send' },
  PAYMENT_PENDING: { bg: 'bg-warning-dim', icon: 'ni-wallet' },
  TRANSFER_PENDING: { bg: 'bg-info-dim', icon: 'ni-swap' },
  COMPLETED: { bg: 'bg-success-dim', icon: 'ni-check-circle' },
  CANCELLED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
  REJECTED: { bg: 'bg-danger-dim', icon: 'ni-cross-circle' },
};

export const menuStatusOptions = [
  { key: 'PENDING', icon: 'ni-file-text' },
  { key: 'KYC_REVIEW', icon: 'ni-shield-check' },
  { key: 'VALIDATION', icon: 'ni-building' },
  { key: 'PAYMENT_PENDING', icon: 'ni-cc-alt2' },
  { key: 'TRANSFER_PENDING', icon: 'ni-swap' },
  { key: 'COMPLETED', icon: 'ni-file-check' },
] as const;
